import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import "./App.css";

import CustomerBooking from "./components/CustomerBooking";
import AdminPanel from "./components/internal/AdminPanel";
import SubmittedComponent from "./components/SubmittedComponent";
import {addLocale, locale} from "primereact/api";
import {all as locales} from "primelocale";
import "primeicons/primeicons.css";
import "primereact/resources/themes/viva-light/theme.css";
import "primereact/resources/themes/tailwind-light/theme.css";
import "primeflex/primeflex.css";
import "primeflex/themes/primeone-light.css";

function App() {
    addLocale("de", locales["de"]);
    locale("de");

    return (
        <Router>
            <Routes>
                <Route path="/" element={<CustomerBooking/>}/>
                <Route path="/admin" element={<AdminPanel/>}/>
                <Route path="/booking/:uuid" element={<SubmittedComponent/>}/>
            </Routes>
        </Router>
    );
}

export default App;
